import api from "./apis";
import { ERROR_MESSAGE, LOADED,LOADING, SUCCESS_MESSAGE, VALIDATION_ERROR } from "./types";
import history from "../history";



export const getAppUsers = (p,ds,de,mobile_number,authenticated) => async (dispatch) => {
  dispatch({ type: LOADING });
  try{
    let response = null;
    if(ds && ds){
      response = await api(localStorage.getItem("token")).get(`/app-management/user?p=${p?p:1}&ds=${ds?ds:""}&de=${de?de:""}&mobile_number=${mobile_number?mobile_number:""}&authenticated=${authenticated?authenticated:''}`);
    }
    else{
      response = await api(localStorage.getItem("token")).get(`/app-management/user?p=${p?p:1}&mobile_number=${mobile_number?mobile_number:""}&authenticated=${authenticated?authenticated:''}`);
    }
    if(response.status === 200 ) {
      dispatch({ type: LOADED });
      return response.data;
    }
  }
  catch( err ){
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
        dispatch({type: LOADED});
      /* ===========End============*/
    }
}

export const getAppUsersDetails = (id) => async (dispatch) => {
  dispatch({ type: LOADING });
  try{
    
    const response = await api(localStorage.getItem("token")).get(`app-management/user/detail?user=${id}`);
    if(response.status === 200 ) {
      dispatch({ type: LOADED });
      return response.data.userDetails;
    }
  }
  catch( err ){
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
        dispatch({type: LOADED});
      /* ===========End============*/
    }
}


export const changeAppUserAuth = (data, remark) => async (dispatch) => {
  dispatch({ type: LOADING });
  try{
  
    const obj = {
        user : data[0],
        authenticated :  data[1],
        remark : remark?.remark,
    }
    const response = await api(localStorage.getItem("token")).patch('app-management/user/auth', {...obj});
    
    if(response.status === 201 ){
        dispatch({ type: SUCCESS_MESSAGE, payload: 'Operation Successful' });
        dispatch({type: LOADED})
        return response.status
    }
  }
  catch( err ){
      /* =============Start========== */
        if(err?.response?.status === 422){
          err.response.data.errors.map(item => {
              dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
          })
        }
        if(err?.response?.status === 401 || err?.response?.status === 403 ){
            dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
            localStorage.clear();
            history.push('/login')
        }
        dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
        dispatch({type: LOADED});
      /* ===========End============*/
    }
};
